<template>
	<BaseModal ref="modal" :title="title" :order="order" modal-class="xl:w-1/2" @cancel="cancel">
		<div class="flex flex-col">
			<div class="image-preview">
				<BaseImage :src="image" :alt="title" :rotation="rotation" :show-rounded="false" @tempDoc="setRotatedImage" class="w-full" />
			</div>

			<div class="flex items-center justify-center mt-5">
				<div class="mr-4">
					{{ $t('rotate_image_hint') }}
				</div>

				<button type="button" class="h-8 cursor-pointer" @click="rotateImage">
					<font-awesome-icon :icon="['fas', 'sync-alt']" class="text-connectProBlue" size="lg" />
				</button>
			</div>

			<div class="flex justify-end mt-6 pt-4 border-t">
				<BaseButton class="mr-2" @click="cancel">
					{{ $t('general.cancel') }}
				</BaseButton>

				<SaveButton class="btn-blue" @click="confirm">
					{{ $t('general.save') }}
				</SaveButton>
			</div>
		</div>
	</BaseModal>
</template>

<script>
import BaseModal from '@/components/modals/BaseModal.vue';
import BaseImage from '@/components/forms/BaseImage';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';

export default {
	name: 'ImageRotationModal',

	components: {
		BaseModal,
		BaseImage,
		BaseButton,
		SaveButton,
	},

	props: {
		title: {
			type: String,
			default: 'Bild ausrichten',
		},

		order: {
			type: Number,
			default: 1,
		},
	},

	data() {
		return {
			image: null,
			rotation: 0,
			confirmAfterRotation: false,
		};
	},

	methods: {
		show(image) {
			this.image = image;
			this.rotation = 0;
			this.confirmAfterRotation = false;

			return this.$refs.modal.show();
		},
		rotateImage() {
			this.rotation = this.rotation === 270 ? 0 : this.rotation + 90;
		},
		confirm() {
			if (!this.image) {
				return;
			}

			if (this.rotation === 0) {
				this.$refs.modal.hide(this.image);
				return;
			}
			this.confirmAfterRotation = true;
		},
		setRotatedImage(image) {
			if (!image) {
				return;
			}

			this.image = image;
			this.rotation = 0;

			if (this.confirmAfterRotation) {
				this.confirmAfterRotation = false;

				this.$refs.modal.hide(this.image);
			}
		},
		cancel() {
			this.rotation = 0;
			this.confirmAfterRotation = false;

			this.$refs.modal.hide(null);
		},
	},
};
</script>

<style scoped>
.image-preview {
	max-height: 65vh;
	overflow: auto;

	display: flex;
	align-items: flex-start;
	justify-content: center;
}
</style>
